export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

      /* eslint-disable */
      function stopRKey(evt) {
          var evt = (evt) ? evt : ((event) ? event : null);
          var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
          if ((evt.keyCode == 13) && (node.type=="text"))  {return false;}
      }

      document.onkeypress = stopRKey;
      /* eslint-enable */

      // function to initialise a new row on Add
      function initialiseRow(rowid) {
          var functioner = jQuery('#input-function-' + rowid);
          var operators = jQuery('#input-operators-' + rowid);
          var handlers = jQuery('.input-handing-' + rowid);
          var blindtype = jQuery('.input-blindtype').val();

          var optionSingle = "<option value='Single'>Single</option>";
          var optionDouble = "<option value='Double'>Double</option>";
          var optionLiftTilt = "<option value='Lift & Tilt'>Lift & Tilt</option>";
          var optionTilt = "<option value='Tilt'>Tilt</option>";
          var optionHandlersLiftTiltLeft = "LH Slide / RH Tilt";
          var optionHandlersLiftTiltRight = "RH Slide / LH Tilt";
          var optionHandlersTiltLeft = "LH Tilt";
          var optionHandlersTiltRight = "RH Tilt";
          //var optionFixedOpen = "<option value='Fixed - open'>Fixed - open</option>";
          //var optionFixedClosed = "<option value='Fixed - closed'>Fixed - closed</option>";

          var privacy = "not selected";
          jQuery('.input-privacy').each(function() {
              if (jQuery(this).prop('checked') === true) {
                  privacy = jQuery(this).val();
              }
          });

          if (privacy === "Yes - false") {

              // function is just tilt
              functioner.html(optionTilt);

              operators.html(optionSingle);

              jQuery.each(handlers, function (key, value) {
                  var thisid = jQuery(value).attr('id');
                  jQuery('#' + thisid).attr('disabled', false);
              });

          } else if (privacy === "Yes - with operator") {

              // function is just lift and tilt
              functioner.html(optionLiftTilt);

              operators.html(optionDouble);

              jQuery.each(handlers, function (key, value) {
                  var thisid = jQuery(value).attr('id');
                  jQuery('#' + thisid).attr('disabled', false);
              });

          } else {

              var functionval = functioner.val();

              if (functionval === "Lift & Tilt") {

                  operators.html(optionSingle + optionDouble);

                  jQuery.each(handlers, function (key, value) {
                      var thisid = jQuery(value).attr('id');
                      jQuery('#' + thisid).attr('disabled', false);
                      // got to work it into here...
                      if (blindtype === "bella") {
                        var exploded = thisid.split("-");
                        var radioid = exploded[0] + "-" + exploded[1] + "-" + exploded[2];
                        var thisrowid = thisid.replace(radioid,'');
                        thisrowid = thisrowid.replace('-','');
                        if (radioid === "input-handing-0") {
                          jQuery('#' + thisid).val(optionHandlersLiftTiltLeft);
                          jQuery(value).next().html('<label>'+optionHandlersLiftTiltLeft+'</label>');
                        } else {
                          jQuery('#' + thisid).val(optionHandlersLiftTiltRight);
                          jQuery(value).next().html('<label>'+optionHandlersLiftTiltRight+'</label>');
                        }
                        jQuery('#item-row-' + thisrowid + ' .handing div').css('opacity',1);
                      }

                  });


                  if (blindtype === "bella") {
                    operators.html(optionDouble);
                  }

              } else if (functionval === "Tilt") {

                  operators.html(optionSingle);

                  jQuery.each(handlers, function (key, value) {
                      var thisid = jQuery(value).attr('id');
                      jQuery('#' + thisid).attr('disabled', false);

                      if (blindtype === "bella") {
                        var exploded = thisid.split("-");
                        var radioid = exploded[0] + "-" + exploded[1] + "-" + exploded[2];
                        var thisrowid = thisid.replace(radioid,'');
                        thisrowid = thisrowid.replace('-','');
                        if (radioid === "input-handing-0") {
                          jQuery('#' + thisid).val(optionHandlersTiltLeft);
                          jQuery(value).next().html('<label>'+optionHandlersTiltLeft+'</label>');
                        } else {
                          jQuery('#' + thisid).val(optionHandlersTiltRight);
                          jQuery(value).next().html('<label>'+optionHandlersTiltRight+'</label>');
                        }
                        jQuery('#item-row-' + thisrowid + ' .handing div').css('opacity',1);
                      }
                  });

              } else if ((functionval === "Fixed - open") || (functionval === "Fixed - closed")) {

                  operators.html("");

                  jQuery.each(handlers, function (key, value) {
                      var thisid = jQuery(value).attr('id');
                      jQuery('#' + thisid).attr('disabled', true);

                      if (blindtype === "bella") {
                        var exploded = thisid.split("-");
                        var radioid = exploded[0] + "-" + exploded[1] + "-" + exploded[2];
                        var thisrowid = thisid.replace(radioid,'');
                        thisrowid = thisrowid.replace('-','');
                        if (radioid === "input-handing-0") {
                          jQuery('#' + thisid).val('');
                          jQuery(value).next().html('<label></label>');
                        } else {
                          jQuery('#' + thisid).val('');
                          jQuery(value).next().html('<label></label>');
                        }
                        jQuery('#item-row-' + thisrowid + ' .handing div').css('opacity',0);

                      }

                  });
              }

          }

      }

      function reOrderRows() {

          var rows = jQuery('.blinds-rows tr');

          jQuery.each(rows, function () {

              // get the id that we need to use across the board
              var id = jQuery(this).find('.input-location').attr('name');
              var newid = id.replace("blinds-row[","").replace("][location]","");

              jQuery(this).attr('id','item-row-' + newid);

              // loop through all fields and set the id's, and update the values appropriately
              jQuery(this).find('.input-location').attr('id','input-location-' + newid);
              jQuery(this).find('.input-location-angela').val('Kit Only');
              //jQuery(this).find('.input-quantity').attr('id','input-quantity-' + newid).val('1');
              jQuery(this).find('.input-width').attr('id','input-width-' + newid);
              jQuery(this).find('.input-height').attr('id','input-height-' + newid);
              jQuery(this).find('.input-function').attr('id','input-function-' + newid);
              jQuery(this).find('.input-operators').attr('id','input-operators-' + newid);
              jQuery(this).find('.input-glass').attr('id','input-glass-' + newid);
              var radios = jQuery(this).find('.input-handing');
              jQuery.each(radios, function(key,value) {
                  var exploded = jQuery(value).attr('id').split("-");
                  var radioid = exploded[0] + "-" + exploded[1] + "-" + exploded[2];
                  jQuery(value).attr('id',radioid + '-' + newid);
                  jQuery(value).next().attr('for',radioid + '-' + newid);
                  jQuery(value).next().removeClass(radioid + '-0');
                  jQuery(value).next().addClass(radioid + '-' + newid);
                  var classes = jQuery(value).attr('class');
                  var rowid = classes.replace("form-check-input input-handing input-handing-","");
                  jQuery(value).removeClass('input-handing-' + rowid);
                  jQuery(value).addClass('input-handing-' + newid);
              });
              jQuery(this).find('.input-total').attr('id','input-total-' + newid);

          });

      }


      // repeater
      jQuery(document).ready(function () {
          jQuery('.item-repeater').repeater({
              // (Optional)
              // start with an empty list of repeaters. Set your first (and only)
              // "data-repeater-item" with style="display:none;" and pass the
              // following configuration flag
              initEmpty: false,
              // (Optional)
              // "defaultValues" sets the values of added items.  The keys of
              // defaultValues refer to the value of the input's name attribute.
              // If a default value is not specified for an input, then it will
              // have its value cleared.
              defaultValues: {},
              // (Optional)
              // "show" is called just after an item is added.  The item is hidden
              // at this point.  If a show callback is not given the item will
              // have $(this).show() called on it.
              show: function () {
                  jQuery(this).fadeIn(300);

                  // calculate what row this is
                  var rowid = jQuery('.variations tr:last').prev().attr('id').replace("item-row-", "");

                  // create new id for the added row
                  var newid = +rowid + 1;

                  // set the row id to be the new id
                  jQuery(this).attr('id','item-row-' + newid);

                  // loop through all fields and set the id's, and update the values appropriately
                  jQuery(this).find('.input-location').attr('id','input-location-' + newid);
                  jQuery(this).find('.input-location-angela').val('Kit Only');
                  jQuery(this).find('.input-quantity').attr('id','input-quantity-' + newid).val('1');
                  jQuery(this).find('.input-width').attr('id','input-width-' + newid);
                  jQuery(this).find('.input-height').attr('id','input-height-' + newid);
                  jQuery(this).find('.input-function').attr('id','input-function-' + newid).val(jQuery('#input-function-' + rowid).val());
                  jQuery(this).find('.input-operators').attr('id','input-operators-' + newid).val(jQuery('#input-operators-' + rowid).val());
                  jQuery(this).find('.input-glass').attr('id','input-glass-' + newid).val(jQuery('#input-glass-' + rowid).val());
                  var radios = jQuery(this).find('.input-handing');
                  jQuery.each(radios, function(key,value) {
                      var exploded = jQuery(value).attr('id').split("-");
                      var radioid = exploded[0] + "-" + exploded[1] + "-" + exploded[2];
                      jQuery(value).attr('id',radioid + '-' + newid);
                      jQuery(value).next().attr('for',radioid + '-' + newid);
                      if (jQuery('#' + radioid + '-' + rowid).prop('checked') === true) {
                          jQuery(value).prop('checked', true);
                      }

                      jQuery(value).removeClass('input-handing-' + rowid);
                      jQuery(value).addClass('input-handing-' + newid);
                  });
                  jQuery(this).find('.input-total').attr('id','input-total-' + newid);


                  initialiseRow(newid);

                  jQuery(this).find('.input-operators').attr('id','input-operators-' + newid).val(jQuery('#input-operators-' + rowid).val());

                  reOrderRows();

              },
              // (Optional)
              // "hide" is called when a user clicks on a data-repeater-delete
              // element.  The item is still visible.  "hide" is passed a function
              // as its first argument which will properly remove the item.
              // "hide" allows for a confirmation step, to send a delete request
              // to the server, etc.  If a hide callback is not given the item
              // will be deleted.
              hide: function () {
                  window.toDelete = jQuery(this);
                  jQuery.confirm({
                      theme: 'modern',
                      icon: 'fa fa-info-circle',
                      title: 'Are you sure?',
                      content: 'Once deleted this row cannot be retrieved.',
                      buttons: {
                          ok: {
                              text: 'Ok',
                              action: function () {
                                  window.toDelete.fadeOut(300, function() {
                                      window.toDelete.remove();
                                      reOrderRows();
                                      recalculate_total_value();
                                  });
                              },
                              btnClass: 'btn-primary',
                          },
                          cancel: {
                              text: 'Cancel',
                          },
                      },
                  });
              },
              // (Optional)
              // You can use this if you need to manually re-index the list
              // for example if you are using a drag and drop library to reorder
              // list items.
              ready: function () {},
              // (Optional)
              // Removes the delete button from the first list item,
              // defaults to false.
              isFirstItemUndeletable: true,
          })
      });

      /* eslint-disable */

      var surrounds = [];
      surrounds['White  RAL 9016'] = 'white-frame';
      surrounds['Cream  RAL 9010'] = 'cream-frame';
      surrounds['Ticking  RAL 7015'] = 'ticking-frame';
      surrounds['Anthracite  RAL 7039'] = 'anthracite-frame';
      surrounds['Rock  RAL 7023'] = 'rock-frame';
      surrounds['Black  RAL 9011'] = 'black-frame';
      surrounds['Silver  RAL 9022'] = 'silver-frame';
      surrounds['Beige  RAL 7035'] = 'beige-frame';
      surrounds['Dark Coffee  RAL 8019'] = 'coffee-frame';
      surrounds['Pearl Bronze  RAL 8011'] = 'bronze-frame';

      var slats = [];
      slats['White  RAL 9016'] = 'white-slats';
      slats['Cream  RAL 9010'] = 'cream-slats';
      slats['Ticking  RAL 7015'] = 'ticking-slats';
      slats['Anthracite  RAL 7039'] = 'anthracite-slats';
      slats['Rock  RAL 7023'] = 'rock-slats';
      slats['Black  RAL 9011'] = 'black-slats';
      slats['Silver  RAL 9022'] = 'silver-slats';
      slats['Beige  RAL 7035'] = 'beige-slats';
      slats['Dark Coffee  RAL 8019'] = 'coffee-slats';
      slats['Pearl Bronze  RAL 8011'] = 'bronze-slats';
      slats['Rainbow'] = 'rainbow-slats';

      // has the surround colour been changed?
      jQuery('.blinds-form-add').on('change', '#input-surroundcolour', function() {
          var selected = jQuery(this).val();
          jQuery('#input-slatcolour').val(selected);

          var background = jQuery('#input-surroundcolour').val();
          var foreground = jQuery('#input-slatcolour').val();

          var flipped = "";
          if ( jQuery('.background').hasClass('flip-image') ) {
            flipped = "-flipped";
          }

          jQuery('.background').attr('src','/app/uploads/blink/' + surrounds[background] + flipped + ".png");
          jQuery('.foreground').attr('src','/app/uploads/blink/' + slats[foreground] + ".png");

      });


      // has the surround colour been changed?
      jQuery('.blinds-form-add').on('change', '#input-slatcolour', function() {

          var background = jQuery('#input-surroundcolour').val();
          var foreground = jQuery('#input-slatcolour').val();

          var flipped = "";
          if ( jQuery('.background').hasClass('flip-image') ) {
            flipped = "-flipped";
          }

          jQuery('.background').attr('src','/app/uploads/blink/' + surrounds[background] + flipped + ".png");
          jQuery('.foreground').attr('src','/app/uploads/blink/' + slats[foreground] + ".png");

      });

      // has the depth been changed?
      jQuery('.blinds-form-add').on('change', '.input-depth', function() {
          var selected = jQuery(this).val();

          var functions = jQuery('#input-function-0').val();
          functions = functions.replace(" &", "");

          if (selected !== "") {
              jQuery.ajax({
                  type: 'POST',
                  url: odl_ajax.url,
                  data: "selected=" + selected + "&function=" + functions + "&action=depth_changed",
                  success: function (data, textStatus, XMLHttpRequest) {

                      var results = jQuery.parseJSON(data);

                      if (results.status === "success") {

                          var optionSingle = "<option value='Single'>Single</option>";
                          var optionDouble = "<option value='Double'>Double</option>";
                          var selectors = jQuery('.input-operators');

                          jQuery('.input-operators').empty();

                          if (results.operators === "both") {
                              jQuery.each(selectors, function (key, value) {
                                  var thisid = jQuery(value).attr('id');
                                  jQuery('#' + thisid).html(optionSingle + optionDouble);
                              });
                          } else if (results.operators === "double") {
                              jQuery.each(selectors, function (key, value) {
                                  var thisid = jQuery(value).attr('id');
                                  jQuery('#' + thisid).html(optionDouble);
                              });
                          } else if (results.operators === "single") {
                              jQuery.each(selectors, function (key, value) {
                                  var thisid = jQuery(value).attr('id');
                                  jQuery('#' + thisid).html(optionSingle);
                              });
                          }

                          jQuery('#note-message').slideUp(300, function () {
                              jQuery('#note-message-error').html('').fadeOut();
                              jQuery('#note-message-info').html(results.message).fadeIn();
                              jQuery('#note-message').slideDown(300).fadeIn();

                          });


                      } else if (results.status === "error") {

                          jQuery('#note-message').slideUp(300, function () {
                              jQuery('#note-message-info').html('').fadeOut();
                              jQuery('#note-message-error').html(results.message).fadeIn();
                              jQuery('#note-message').slideDown(300).fadeIn();
                          });

                      }

                  },
                  error: function (MLHttpRequest, textStatus, errorThrown) {
                      console.log(MLHttpRequest);
                      console.log(textStatus);
                      console.log(errorThrown);
                      alert('Error, please contact support.');
                  },
              });
          }

      });


      // has the privacy been changed?
      jQuery('.blinds-form-add').on('change', '.input-privacy', function() {
          var selected = jQuery(this).val();

          // first check if there are any rows in play already

          jQuery.confirm({
              theme: 'modern',
              icon: 'fa fa-info-circle',
              title: 'Privacy Channel',
              content: 'Changing the privacy channel may affect any rows already entered below.',
              buttons: {
                  ok: {
                      text: 'Ok',
                      btnClass: 'btn-primary',
                      action: function () {

                          if (selected !== "") {
                              jQuery.ajax({
                                  type: 'POST',
                                  url: odl_ajax.url,
                                  data: "privacy=" + selected + "&action=privacy_changed",
                                  success: function (data, textStatus, XMLHttpRequest) {

                                      var results = jQuery.parseJSON(data);

                                      if (results.status === "success") {

                                          var optionSingle = "<option value='Single'>Single</option>";
                                          var optionDouble = "<option value='Double'>Double</option>";
                                          var optionNA = "<option value='NA'>N/A</option>";
                                          var optionLiftTilt = "<option value='Lift & Tilt'>Lift & Tilt</option>";
                                          var optionTilt = "<option value='Tilt'>Tilt</option>";
                                          var optionFixedOpen = "<option value='Fixed - open'>Fixed - open</option>";
                                          var optionFixedClosed = "<option value='Fixed - closed'>Fixed - closed</option>";
                                          var selectors = jQuery('.input-operators');
                                          var functioners = jQuery('.input-function');

                                          jQuery('.input-operators').empty();

                                          if (results.operators === "both") {
                                              jQuery.each(selectors, function (key, value) {
                                                  var thisid = jQuery(value).attr('id');
                                                  jQuery('#' + thisid).html(optionSingle + optionDouble);
                                              });
                                              jQuery.each(functioners, function (key, value) {
                                                  var thisid = jQuery(value).attr('id');
                                                  jQuery('#' + thisid).html(optionLiftTilt + optionTilt + optionFixedOpen + optionFixedClosed);
                                              });
                                          } else if (results.operators === "single") {
                                              jQuery.each(selectors, function (key, value) {
                                                  var thisid = jQuery(value).attr('id');
                                                  jQuery('#' + thisid).html(optionSingle);
                                              });
                                              jQuery.each(functioners, function (key, value) {
                                                  var thisid = jQuery(value).attr('id');
                                                  jQuery('#' + thisid).html(optionTilt);
                                              });

                                              jQuery('#note-message').slideUp(300, function () {
                                                  if (results.message != "") {
                                                      jQuery('#note-message-error').html('').fadeOut();
                                                      jQuery('#note-message-info').html(results.message).fadeIn();
                                                      jQuery('#note-message').slideDown(300).fadeIn();
                                                  }
                                              });
                                          } else if (results.operators === "double") {
                                              jQuery.each(selectors, function (key, value) {
                                                  var thisid = jQuery(value).attr('id');
                                                  jQuery('#' + thisid).html(optionDouble);
                                              });
                                              jQuery.each(functioners, function (key, value) {
                                                  var thisid = jQuery(value).attr('id');
                                                  jQuery('#' + thisid).html(optionLiftTilt);
                                              });
                                              jQuery.confirm({
                                                  theme: 'modern',
                                                  icon: 'fa fa-info-circle',
                                                  title: 'Privacy Channel',
                                                  content: 'A privacy channel with operator means you can only select Lift & Tilt as a function, with double operators.',
                                                  buttons: {
                                                      ok: {
                                                          text: 'Ok',
                                                          btnClass: 'btn-primary',
                                                      }
                                                  },
                                              });
                                              jQuery('#note-message').slideUp(300, function () {
                                                  if (results.message != "") {
                                                      jQuery('#note-message-error').html('').fadeOut();
                                                      jQuery('#note-message-info').html(results.message).fadeIn();
                                                      jQuery('#note-message').slideDown(300).fadeIn();
                                                  }
                                              });

                                          }


                                          var recalcformdata = jQuery('#blinds-form-add').serialize();
                                          // now recalculate all the rows
                                          jQuery('.blinds-rows tr').each(function() {
                                            var rowid = jQuery(this).attr('id');
                                            rowid = rowid.replace("item-row-", "");

                                            jQuery.ajax({
                                              type: 'POST',
                                              url: odl_ajax.url,
                                              data: recalcformdata + "&row=" + rowid + "&action=quantity_changed",
                                              success: function (data, textStatus, XMLHttpRequest) {

                                                var results = jQuery.parseJSON(data);

                                                if (results.status === "success") {

                                                  if (results.message === true) {

                                                    // all good, update the total
                                                    if (results.totalprice !== 0) {
                                                      jQuery('#input-total-' + results.row).val(results.totalprice);
                                                    } else {
                                                      jQuery('#input-total-' + results.row).val('');
                                                    }

                                                  } else {

                                                    // not good, remove the total

                                                    jQuery('#input-total-' + results.row).val('');

                                                  }

                                                } else if (results.status === "error") {

                                                  console.log('error');

                                                }

                                              },
                                              error: function (MLHttpRequest, textStatus, errorThrown) {
                                                console.log(MLHttpRequest);
                                                console.log(textStatus);
                                                console.log(errorThrown);
                                                alert('Error, please contact support.');
                                              },
                                            });


                                          });

                                          // now recalculate the totals
                                          recalculate_total_value();

                                      } else if (results.status === "error") {

                                      }

                                  },
                                  error: function (MLHttpRequest, textStatus, errorThrown) {
                                      console.log(MLHttpRequest);
                                      console.log(textStatus);
                                      console.log(errorThrown);
                                      alert('Error, please contact support.');
                                  },
                              });
                          }

                      }
                  },
                  cancel: {
                      text: 'Cancel',
                      action: function() {

                          var checked = jQuery('.input-privacy:checked').val();

                          if (checked === "No") {

                              jQuery('#input-privacy0').prop('checked', false);
                              jQuery('#input-privacy1').prop('checked', true);

                          } else if (checked === "Yes") {

                              jQuery('#input-privacy0').prop('checked', true);
                              jQuery('#input-privacy1').prop('checked', false);

                          } else if (checked === "Yes - false") {

                              jQuery('#input-privacy0').prop('checked', false);
                              jQuery('#input-privacy1').prop('checked', true);

                          } else if (checked === "Yes - with operator") {

                              jQuery('#input-privacy0').prop('checked', true);
                              jQuery('#input-privacy1').prop('checked', false);

                          }

                      }
                  }
              },
          });
      });


      // has the function been changed?
      jQuery('.blinds-form-add').on('change', '.input-function', function() {
          var rowid = jQuery(this).attr('id').replace("input-function-","");
          var selected = jQuery(this).val();
          var privacy = jQuery('.input-privacy').val();
          var blindtype = jQuery('.input-blindtype').val();
          selected = selected.replace(" &", "");

          var width = jQuery('#input-width-' + rowid).val();
          var height = jQuery('#input-height-' + rowid).val();

          var formdata = jQuery('#blinds-form-add').serialize();

          if (selected !== "") {
              jQuery.ajax({
                  type: 'POST',
                  url: odl_ajax.url,
                  data: formdata + "&blindtype=" + blindtype + "&function=" + selected + "&row=" + rowid + "&privacy=" + privacy + "&width=" + width + "&height=" + height + "&action=function_changed",
                  success: function (data, textStatus, XMLHttpRequest) {

                      var results = jQuery.parseJSON(data);

                      var optionSingle = "<option value='Single'>Single</option>";
                      var optionDouble = "<option value='Double'>Double</option>";
                      var optionNA = "<option value='' selected></option>";
                      var selector = jQuery('#input-operators-' + rowid);
                      var handing = jQuery('.input-handing-' + rowid);
                      var optionHandlersLiftTiltLeft = "LH Slide / RH Tilt";
                      var optionHandlersLiftTiltRight = "RH Slide / LH Tilt";
                      var optionHandlersTiltLeft = "LH Tilt";
                      var optionHandlersTiltRight = "RH Tilt";


                      if (results.status === "success") {

                          if (results.operators === "both") {
                              selector.html(optionSingle + optionDouble);
                              selector.attr('disabled',false);
                          } else if (results.operators === "single") {
                              selector.html(optionSingle);
                              selector.attr('disabled',false);
                          } else if (results.operators === "double") {
                              selector.html(optionDouble);
                              selector.attr('disabled',false);
                          } else if (results.operators === "none") {
                              selector.html(optionNA);
                              selector.attr('disabled',true);
                          }

                          if (results.handing === "true") {
                              handing.attr('disabled',false);
                          } else if (results.handing === "false") {
                              handing.attr('disabled',true);
                          }


                          if (results.blindtype === "bella") {

                            if (results.function === "Tilt") {

                              jQuery('#input-handing-0-' + rowid).val(optionHandlersTiltLeft);
                              jQuery('#input-handing-1-' + rowid).val(optionHandlersTiltRight);
                              jQuery('.input-handing-0-' + rowid + ' label').html(optionHandlersTiltLeft);
                              jQuery('.input-handing-1-' + rowid + ' label').html(optionHandlersTiltRight);
                              jQuery('#item-row-' + rowid + ' .handing div').css('opacity',1);

                            } else if (results.function === "Lift Tilt") {

                              jQuery('#input-handing-0-' + rowid).val(optionHandlersLiftTiltLeft);
                              jQuery('#input-handing-1-' + rowid).val(optionHandlersLiftTiltRight);
                              jQuery('.input-handing-0-' + rowid + ' label').html(optionHandlersLiftTiltLeft);
                              jQuery('.input-handing-1-' + rowid + ' label').html(optionHandlersLiftTiltRight);
                              jQuery('#item-row-' + rowid + ' .handing div').css('opacity',1);

                            } else {

                              jQuery('#input-handing-0-' + rowid).val('');
                              jQuery('#input-handing-1-' + rowid).val('');
                              jQuery('#item-row-' + rowid + ' .handing div').css('opacity',0);

                            }

                          }

                      } else if (results.status === "error") {

                      }

                      // and the results of the dimensions check go here...


                      if (results.testwidth === true) {
                          if (results.width.message === true) {

                              // all good, change both to green and update the total
                              jQuery('#input-' + results.width.type + '-' + results.width.row).removeClass('invalid-entry').addClass('valid-entry');

                              if (results.width.totalprice !== 0) {
                                  jQuery('#input-total-' + results.width.row).val(results.width.totalprice);
                              } else {
                                  jQuery('#input-total-' + results.width.row).val('');
                              }

                              // remove any tooltips
                              jQuery('#input-' + 'width' + '-' + results.width.row).tooltip('dispose');

                          } else {

                              // not good, change it to red and remove the total
                              jQuery('#input-' + results.width.type + '-' + results.width.row).removeClass('valid-entry').addClass('invalid-entry');
                              jQuery('#input-total-' + results.width.row).val('');

                              // add the tooltip which gives advice on available sizes
                              var placement = "left";

                              jQuery('#input-' + results.width.type + '-' + results.width.row).tooltip('dispose').tooltip({
                                  trigger: 'manual',
                                  title: 'Valid ' + results.width.type + 's are: ' + results.width.tooltip.min + 'mm to ' + results.width.tooltip.max + 'mm',
                                  offset: '300',
                                  placement: placement
                              }).tooltip('show');

                              /*if (results.width.type == "width") {
                                  var other = "height";
                              } else {
                                  var other = "width";
                              }
                              jQuery('#input-' + other + '-' + results.width.row).tooltip('dispose');*/

                          }
                      }



                      if (results.testheight === true) {
                          if (results.height.message === true) {

                              // all good, change both to green and update the total
                              jQuery('#input-' + results.height.type + '-' + results.height.row).removeClass('invalid-entry').addClass('valid-entry');

                              if (results.height.totalprice !== 0) {
                                  jQuery('#input-total-' + results.height.row).val(results.height.totalprice);
                              } else {
                                  jQuery('#input-total-' + results.height.row).val('');
                              }

                              // remove any tooltips
                              jQuery('#input-' + 'height' + '-' + results.height.row).tooltip('dispose');

                          } else {

                              // not good, change it to red and remove the total
                              jQuery('#input-' + results.height.type + '-' + results.height.row).removeClass('valid-entry').addClass('invalid-entry');
                              jQuery('#input-total-' + results.height.row).val('');

                              var placement = "right";

                              // add the tooltip which gives advice on available sizes
                              jQuery('#input-' + results.height.type + '-' + results.height.row).tooltip('dispose').tooltip({
                                  trigger: 'manual',
                                  title: 'Valid ' + results.height.type + 's are: ' + results.height.tooltip.min + 'mm to ' + results.height.tooltip.max + 'mm',
                                  offset: '300',
                                  placement: placement
                              }).tooltip('show');

                              /*if (results.width.type == "width") {
                               var other = "height";
                               } else {
                               var other = "width";
                               }
                               jQuery('#input-' + other + '-' + results.width.row).tooltip('dispose');*/

                          }
                      }

                      recalculate_total_value();

                  },
                  error: function (MLHttpRequest, textStatus, errorThrown) {
                      console.log(MLHttpRequest);
                      console.log(textStatus);
                      console.log(errorThrown);
                      alert('Error, please contact support.');
                  },
              });
          }

      });


      // has the glass been changed?
      jQuery('.blinds-form-add').on('change', '.input-glass', function() {
          var rowid = jQuery(this).attr('id').replace("input-glass-","");

          var selected = jQuery('#input-function-' + rowid).val();
          var privacy = jQuery('.input-privacy').val();
          selected = selected.replace(" &", "");

          var width = jQuery('#input-width-' + rowid).val();
          var height = jQuery('#input-height-' + rowid).val();

          var formdata = jQuery('#blinds-form-add').serialize();

          if (selected !== "") {
              jQuery.ajax({
                  type: 'POST',
                  url: odl_ajax.url,
                  data: formdata + "&function=" + selected + "&row=" + rowid + "&privacy=" + privacy + "&width=" + width + "&height=" + height + "&action=function_changed",
                  success: function (data, textStatus, XMLHttpRequest) {

                      var results = jQuery.parseJSON(data);

                      var optionSingle = "<option value='Single'>Single</option>";
                      var optionDouble = "<option value='Double'>Double</option>";
                      var optionNA = "<option value='' selected></option>";
                      var selector = jQuery('#input-operators-' + rowid);
                      var handing = jQuery('.input-handing-' + rowid);

                      if (results.status === "success") {

                          /*if (results.operators === "both") {
                              selector.html(optionSingle + optionDouble);
                              selector.attr('disabled',false);
                          } else if (results.operators === "single") {
                              selector.html(optionSingle);
                              selector.attr('disabled',false);
                          } else if (results.operators === "none") {
                              selector.html(optionNA);
                              selector.attr('disabled',true);
                          }

                          if (results.handing === "true") {
                              handing.attr('disabled',false);
                          } else if (results.handing === "false") {
                              handing.attr('disabled',true);
                          }*/

                      } else if (results.status === "error") {

                      }

                      // and the results of the dimensions check go here...


                      if (results.testwidth === true) {
                          if (results.width.message === true) {

                              // all good, change both to green and update the total
                              //jQuery('#input-' + results.width.type + '-' + results.width.row).removeClass('invalid-entry').addClass('valid-entry');

                              if (results.width.totalprice !== 0) {
                                  jQuery('#input-total-' + results.width.row).val(results.width.totalprice);
                              } else {
                                  jQuery('#input-total-' + results.width.row).val('');
                              }

                              // remove any tooltips
                              //jQuery('#input-' + 'width' + '-' + results.width.row).tooltip('dispose');

                          } else {
/*
                              // not good, change it to red and remove the total
                              jQuery('#input-' + results.width.type + '-' + results.width.row).removeClass('valid-entry').addClass('invalid-entry');
                              jQuery('#input-total-' + results.width.row).val('');

                              // add the tooltip which gives advice on available sizes
                              var placement = "left";

                              jQuery('#input-' + results.width.type + '-' + results.width.row).tooltip('dispose').tooltip({
                                  trigger: 'manual',
                                  title: 'Valid ' + results.width.type + 's are: ' + results.width.tooltip.min + 'mm to ' + results.width.tooltip.max + 'mm',
                                  offset: '300',
                                  placement: placement
                              }).tooltip('show');

                              /*if (results.width.type == "width") {
                               var other = "height";
                               } else {
                               var other = "width";
                               }
                               jQuery('#input-' + other + '-' + results.width.row).tooltip('dispose');*/

                          }
                      }



                      if (results.testheight === true) {
                          if (results.height.message === true) {

                              // all good, change both to green and update the total
                              //jQuery('#input-' + results.height.type + '-' + results.height.row).removeClass('invalid-entry').addClass('valid-entry');

                              if (results.height.totalprice !== 0) {
                                  jQuery('#input-total-' + results.height.row).val(results.height.totalprice);
                              } else {
                                  jQuery('#input-total-' + results.height.row).val('');
                              }

                              // remove any tooltips
                              //jQuery('#input-' + 'height' + '-' + results.height.row).tooltip('dispose');

                          } else {
/*
                              // not good, change it to red and remove the total
                              jQuery('#input-' + results.height.type + '-' + results.height.row).removeClass('valid-entry').addClass('invalid-entry');
                              jQuery('#input-total-' + results.height.row).val('');

                              var placement = "right";

                              // add the tooltip which gives advice on available sizes
                              jQuery('#input-' + results.height.type + '-' + results.height.row).tooltip('dispose').tooltip({
                                  trigger: 'manual',
                                  title: 'Valid ' + results.height.type + 's are: ' + results.height.tooltip.min + 'mm to ' + results.height.tooltip.max + 'mm',
                                  offset: '300',
                                  placement: placement
                              }).tooltip('show');

                              /*if (results.width.type == "width") {
                               var other = "height";
                               } else {
                               var other = "width";
                               }
                               jQuery('#input-' + other + '-' + results.width.row).tooltip('dispose');*/

                          }
                      }

                      recalculate_total_value();

                  },
                  error: function (MLHttpRequest, textStatus, errorThrown) {
                      console.log(MLHttpRequest);
                      console.log(textStatus);
                      console.log(errorThrown);
                      alert('Error, please contact support.');
                  },
              });
          }

      });


      // has the operators been changed?
      jQuery('.blinds-form-add').on('change', '.input-operators', function() {
          var rowid = jQuery(this).attr('id').replace("input-operators-","");
          var selected = jQuery(this).val();
          var privacy = jQuery('.input-privacy').val();
          var functions = jQuery('#input-function-' + rowid).val();
          functions = functions.replace(" &", "");

          var width = jQuery('#input-width-' + rowid).val();
          var height = jQuery('#input-height-' + rowid).val();

          var formdata = jQuery('#blinds-form-add').serialize();

          if (selected !== "") {
              jQuery.ajax({
                  type: 'POST',
                  url: odl_ajax.url,
                  data: formdata + "&operators=" + selected + "&function=" + functions + "&row=" + rowid + "&privacy=" + privacy + "&width=" + width + "&height=" + height + "&action=operators_changed",
                  success: function (data, textStatus, XMLHttpRequest) {

                      var results = jQuery.parseJSON(data);

                      var optionSingle = "<option value='Single'>Single</option>";
                      var optionDouble = "<option value='Double'>Double</option>";
                      var optionNA = "<option value='' selected></option>";
                      var selector = jQuery('#input-operators-' + rowid);
                      var handing = jQuery('.input-handing-' + rowid);

                      if (results.status === "success") {

                          if (results.operators === "both") {
                              selector.html(optionSingle + optionDouble);
                              selector.attr('disabled',false);
                          } else if (results.operators === "single") {
                              selector.html(optionSingle);
                              selector.attr('disabled',false);
                          } else if (results.operators === "none") {
                              selector.html(optionNA);
                              selector.attr('disabled',true);
                          }

                          if (results.handing === "true") {
                              handing.attr('disabled',false);
                          } else if (results.handing === "false") {
                              handing.attr('disabled',true);
                          }

                      } else if (results.status === "error") {

                      }

                      // and the results of the dimensions check go here...


                      if (results.testwidth === true) {
                          if (results.width.message === true) {

                              // all good, change both to green and update the total
                              jQuery('#input-' + results.width.type + '-' + results.width.row).removeClass('invalid-entry').addClass('valid-entry');

                              if (results.width.totalprice !== 0) {
                                  jQuery('#input-total-' + results.width.row).val(results.width.totalprice);
                              } else {
                                  jQuery('#input-total-' + results.width.row).val('');
                              }

                              // remove any tooltips
                              jQuery('#input-' + 'width' + '-' + results.width.row).tooltip('dispose');

                          } else {

                              // not good, change it to red and remove the total
                              jQuery('#input-' + results.width.type + '-' + results.width.row).removeClass('valid-entry').addClass('invalid-entry');
                              jQuery('#input-total-' + results.width.row).val('');

                              // add the tooltip which gives advice on available sizes
                              var placement = "left";

                              jQuery('#input-' + results.width.type + '-' + results.width.row).tooltip('dispose').tooltip({
                                  trigger: 'manual',
                                  title: 'Valid ' + results.width.type + 's are: ' + results.width.tooltip.min + 'mm to ' + results.width.tooltip.max + 'mm',
                                  offset: '300',
                                  placement: placement
                              }).tooltip('show');

                              /*if (results.width.type == "width") {
                               var other = "height";
                               } else {
                               var other = "width";
                               }
                               jQuery('#input-' + other + '-' + results.width.row).tooltip('dispose');*/

                          }
                      }



                      if (results.testheight === true) {
                          if (results.height.message === true) {

                              // all good, change both to green and update the total
                              jQuery('#input-' + results.height.type + '-' + results.height.row).removeClass('invalid-entry').addClass('valid-entry');

                              if (results.height.totalprice !== 0) {
                                  jQuery('#input-total-' + results.height.row).val(results.height.totalprice);
                              } else {
                                  jQuery('#input-total-' + results.height.row).val('');
                              }

                              // remove any tooltips
                              jQuery('#input-' + 'height' + '-' + results.height.row).tooltip('dispose');

                          } else {

                              // not good, change it to red and remove the total
                              jQuery('#input-' + results.height.type + '-' + results.height.row).removeClass('valid-entry').addClass('invalid-entry');
                              jQuery('#input-total-' + results.height.row).val('');

                              var placement = "right";

                              // add the tooltip which gives advice on available sizes
                              jQuery('#input-' + results.height.type + '-' + results.height.row).tooltip('dispose').tooltip({
                                  trigger: 'manual',
                                  title: 'Valid ' + results.height.type + 's are: ' + results.height.tooltip.min + 'mm to ' + results.height.tooltip.max + 'mm',
                                  offset: '300',
                                  placement: placement
                              }).tooltip('show');

                              /*if (results.width.type == "width") {
                               var other = "height";
                               } else {
                               var other = "width";
                               }
                               jQuery('#input-' + other + '-' + results.width.row).tooltip('dispose');*/

                          }
                      }

                      recalculate_total_value();

                  },
                  error: function (MLHttpRequest, textStatus, errorThrown) {
                      console.log(MLHttpRequest);
                      console.log(textStatus);
                      console.log(errorThrown);
                      alert('Error, please contact support.');
                  },
              });
          }

      });




      // has the depth been changed?
      jQuery('.blinds-form-add').on('change', '.input-dimension', function() {
          var rowid = jQuery(this).attr('id').replace("input-width-","").replace("input-height-","");

          // determine if it's a width or height change
          var type = "unset";
          if (jQuery(this).hasClass('input-width')) {
              type = "width";
          }
          if (jQuery(this).hasClass('input-height')) {
              type = "height";
          }

          var formdata = jQuery('#blinds-form-add').serialize();

          jQuery.ajax({
              type: 'POST',
              url: odl_ajax.url,
              data: formdata + "&row=" + rowid + "&type=" + type + "&action=dimensions_changed",
              success: function(data, textStatus, XMLHttpRequest) {

                  var results = jQuery.parseJSON(data);

                  if (results.status === "success") {

                      if (results.message === true) {

                          // all good, change both to green and update the total
                          jQuery('#input-' + results.type + '-' + results.row).removeClass('invalid-entry').addClass('valid-entry');

                          if (results.totalprice !== 0) {
                              jQuery('#input-total-' + results.row).val(results.totalprice);
                          } else {
                              jQuery('#input-total-' + results.row).val('');
                          }

                          // remove any tooltips
                          jQuery('#input-' + 'width' + '-' + results.row).tooltip('dispose');
                          jQuery('#input-' + 'height' + '-' + results.row).tooltip('dispose');

                      } else {

                          // not good, change it to red and remove the total
                          jQuery('#input-' + results.type + '-' + results.row).removeClass('valid-entry').addClass('invalid-entry');
                          jQuery('#input-total-' + results.row).val('');

                          var placement = "left";
                          if (results.type == 'height') {
                              placement = "right";
                          }

                          // add the tooltip which gives advice on available sizes
                          jQuery('#input-' + results.type + '-' + results.row).tooltip('dispose').tooltip({
                              trigger: 'manual',
                              title: 'Valid ' + results.type + 's are: ' + results.tooltip.min + 'mm to ' + results.tooltip.max + 'mm',
                              offset: '300',
                              placement: placement
                          }).tooltip('show');

                          if (results.type == "width") {
                              var other = "height";
                          } else {
                              var other = "width";
                          }
                          jQuery('#input-' + other + '-' + results.row).tooltip('dispose');

                      }

                      recalculate_total_value();

                  } else if (results.status === "error") {

                      console.log('error');

                      /*jQuery('#note-message').slideUp(300, function() {
                       jQuery('#note-message-info').html('').fadeOut();
                       jQuery('#note-message-error').html(results.message).fadeIn();
                       jQuery('#note-message').slideDown(300).fadeIn();
                       });*/

                  }

              },
              error: function(MLHttpRequest, textStatus, errorThrown) {
                  console.log(MLHttpRequest);
                  console.log(textStatus);
                  console.log(errorThrown);
                  alert('Error, please contact support.');
              },
          });

      });

      // has a qty been changed?
      jQuery('.blinds-form-add').on('change', '.input-quantity', function() {
          var rowid = jQuery(this).attr('id').replace("input-quantity-","");
          var worthdoing = false;

          if ( (jQuery('#input-width-' + rowid).val() !== "") && (jQuery('#input-height-' + rowid).val() !== "") ) {
            worthdoing = true;
          }

          if (worthdoing) {

              var formdata = jQuery('#blinds-form-add').serialize();

              jQuery.ajax({
                  type: 'POST',
                  url: odl_ajax.url,
                  data: formdata + "&row=" + rowid + "&action=quantity_changed",
                  success: function (data, textStatus, XMLHttpRequest) {

                      var results = jQuery.parseJSON(data);

                      if (results.status === "success") {

                          if (results.message === true) {

                              // all good, update the total
                              if (results.totalprice !== 0) {
                                  jQuery('#input-total-' + results.row).val(results.totalprice);
                              } else {
                                  jQuery('#input-total-' + results.row).val('');
                              }

                          } else {

                              // not good, remove the total

                              jQuery('#input-total-' + results.row).val('');

                          }

                          recalculate_total_value();

                      } else if (results.status === "error") {

                          console.log('error');

                          /*jQuery('#note-message').slideUp(300, function() {
                           jQuery('#note-message-info').html('').fadeOut();
                           jQuery('#note-message-error').html(results.message).fadeIn();
                           jQuery('#note-message').slideDown(300).fadeIn();
                           });*/

                      }

                  },
                  error: function (MLHttpRequest, textStatus, errorThrown) {
                      console.log(MLHttpRequest);
                      console.log(textStatus);
                      console.log(errorThrown);
                      alert('Error, please contact support.');
                  },
              });

          }

      });

      jQuery( ".delete-product" ).click(function() {

          var rowid = jQuery(this).attr('data-delete-id');

          jQuery.confirm({
              theme: 'modern',
              icon: 'fa fa-info-circle',
              title: 'Are you sure?',
              content: 'Once deleted this row cannot be retrieved.',
              buttons: {
                  ok: {
                      text: 'Ok',
                      action: function () {

                          jQuery.ajax({
                              type: 'POST',
                              url: odl_ajax.url,
                              data: "row=" + rowid + "&from=minibasket&action=delete_product",
                              success: function (data, textStatus, XMLHttpRequest) {

                                  var results = jQuery.parseJSON(data);

                                  if (results.status === "success") {

                                      jQuery('#minibasket-row-' + rowid).slideUp(500, function() {
                                          jQuery('#minibasket-row-' + rowid).remove();
                                      });

                                      setTimeout(function(){

                                          // are there any left?
                                          var count = jQuery('.minibasket-row').length;

                                          console.log(count);

                                          if (count === 0) {
                                              jQuery('.minibasket').slideUp(500, function() {
                                                  jQuery('.minibasket').remove();
                                              });
                                          }

                                      }, 600);

                                  } else if (results.status === "error") {

                                      console.log('error');

                                  }

                              },
                              error: function (MLHttpRequest, textStatus, errorThrown) {
                                  console.log(MLHttpRequest);
                                  console.log(textStatus);
                                  console.log(errorThrown);
                                  alert('Error, please contact support.');
                              },
                          });


                      },
                      btnClass: 'btn-primary',
                  },
                  cancel: {
                      text: 'Cancel',
                  },
              },
          });

      });


      jQuery( ".delete-summary-product" ).click(function() {

          var rowid = jQuery(this).attr('data-delete-id');

          jQuery.confirm({
              theme: 'modern',
              icon: 'fa fa-info-circle',
              title: 'Are you sure?',
              content: 'Once deleted this row cannot be retrieved.',
              buttons: {
                  ok: {
                      text: 'Ok',
                      action: function () {

                          jQuery.ajax({
                              type: 'POST',
                              url: odl_ajax.url,
                              data: "row=" + rowid + "&from=summary&action=delete_product",
                              success: function (data, textStatus, XMLHttpRequest) {

                                  var results = jQuery.parseJSON(data);

                                  if (results.status === "success") {
                                      jQuery('#item-row-' + rowid).slideUp(500, function() {
                                          jQuery('#item-row-' + rowid).remove();
                                      });
                                      jQuery('.separator-' + rowid).slideUp(500, function() {
                                          jQuery('.separator-' + rowid).remove();
                                      });

                                      var subtotal = parseFloat(results.subtotal).toFixed(2);
                                      var deliverycost = parseFloat(results.deliverycost).toFixed(2);
                                      var total = parseFloat(results.total).toFixed(2);
                                      var vat = parseFloat(results.vat).toFixed(2);
                                      var grand_total = parseFloat(results.grand_total).toFixed(2);

                                      jQuery('#subtotal').html(subtotal);
                                      jQuery('#deliverycost').html(deliverycost);
                                      jQuery('#vat').html(vat);
                                      jQuery('#total').html(grand_total);

                                      /*setTimeout(function(){

                                          // are there any left?
                                          var count = jQuery('.minibasket-row').length;

                                          console.log(count);

                                          if (count === 0) {
                                              jQuery('.minibasket').slideUp(500, function() {
                                                  jQuery('.minibasket').remove();
                                              });
                                          }

                                      }, 600);*/

                                  } else if (results.status === "error") {

                                      console.log('error');

                                  }

                              },
                              error: function (MLHttpRequest, textStatus, errorThrown) {
                                  console.log(MLHttpRequest);
                                  console.log(textStatus);
                                  console.log(errorThrown);
                                  alert('Error, please contact support.');
                              },
                          });


                      },
                      btnClass: 'btn-primary',
                  },
                  cancel: {
                      text: 'Cancel',
                  },
              },
          });

      });


      jQuery( ".delete-quote" ).click(function() {

          var quoteid = jQuery(this).attr('data-delete-id');

          jQuery.confirm({
              theme: 'modern',
              icon: 'fa fa-info-circle',
              title: 'Are you sure?',
              content: 'Once deleted this quote cannot be retrieved.',
              buttons: {
                  ok: {
                      text: 'Ok',
                      action: function () {

                          jQuery.ajax({
                              type: 'POST',
                              url: odl_ajax.url,
                              data: "uid=" + quoteid + "&action=delete_quote",
                              success: function (data, textStatus, XMLHttpRequest) {

                                  var results = jQuery.parseJSON(data);

                                  if (results.status === "success") {

                                      jQuery('#item-row-' + quoteid).slideUp(500, function() {
                                          jQuery('#item-row-' + quoteid).remove();
                                      });

                                      jQuery('.separator-' + quoteid).slideUp(500, function() {
                                          jQuery('#separator-' + quoteid).remove();
                                      });

                                  } else if (results.status === "error") {

                                      console.log('error');

                                  }

                              },
                              error: function (MLHttpRequest, textStatus, errorThrown) {
                                  console.log(MLHttpRequest);
                                  console.log(textStatus);
                                  console.log(errorThrown);
                                  alert('Error, please contact support.');
                              },
                          });


                      },
                      btnClass: 'btn-primary',
                  },
                  cancel: {
                      text: 'Cancel',
                  },
              },
          });

      });









      jQuery( ".send-quote" ).click(function() {

          var sendid = jQuery(this).attr('data-send-id');

          jQuery.confirm({
              theme: 'modern',
              icon: 'fa fa-info-circle',
              title: 'Are you sure?',
              content: 'Click ok to send this quote as an email.',
              buttons: {
                  ok: {
                      text: 'Ok',
                      action: function () {

                          jQuery.ajax({
                              type: 'POST',
                              url: odl_ajax.url,
                              data: "uid=" + sendid + "&action=send_quote",
                              success: function (data, textStatus, XMLHttpRequest) {

                                  var results = jQuery.parseJSON(data);

                                  if (results.status === "success") {

                                      /*jQuery('#item-row-' + quoteid).slideUp(500, function() {
                                          jQuery('#item-row-' + quoteid).remove();
                                      });

                                      jQuery('.separator-' + quoteid).slideUp(500, function() {
                                          jQuery('#separator-' + quoteid).remove();
                                      });*/

                                  } else if (results.status === "error") {

                                      console.log('error');

                                  }

                              },
                              error: function (MLHttpRequest, textStatus, errorThrown) {
                                  console.log(MLHttpRequest);
                                  console.log(textStatus);
                                  console.log(errorThrown);
                                  alert('Error, please contact support.');
                              },
                          });


                      },
                      btnClass: 'btn-primary',
                  },
                  cancel: {
                      text: 'Cancel',
                  },
              },
          });

      });





      function recalculate_total_value() {

          var formdata = jQuery('#blinds-form-add').serialize();

          jQuery.ajax({
              type: 'POST',
              url: odl_ajax.url,
              data: formdata + "&action=calculate_total_value",
              success: function (data, textStatus, XMLHttpRequest) {

                  var results = jQuery.parseJSON(data);

                  if (results.status === "success") {

                      if (results.totalvalue !== 0) {

                          // all good, update the grand total
                          jQuery('#total-value').val(results.totalvalue);

                      } else {

                          // not good, remove the grand total
                          jQuery('#total-value').val('');

                      }

                  } else if (results.status === "error") {

                      console.log('error');

                      /*jQuery('#note-message').slideUp(300, function() {
                       jQuery('#note-message-info').html('').fadeOut();
                       jQuery('#note-message-error').html(results.message).fadeIn();
                       jQuery('#note-message').slideDown(300).fadeIn();
                       });*/

                  }

              },
              error: function (MLHttpRequest, textStatus, errorThrown) {
                  console.log(MLHttpRequest);
                  console.log(textStatus);
                  console.log(errorThrown);
                  alert('Error, please contact support.');
              },
          });

      }


      jQuery('.order-processing').on('change', '.input-action', function() {

          var order_uid = jQuery(this).data('approve');
          var action = jQuery(this).val();

          if (action === "approve") {
              jQuery('#input-sage-' + order_uid).slideDown();
              jQuery('#input-note-' + order_uid).slideUp();
              jQuery('#input-notes-' + order_uid).slideDown();
          } else if (action === "reject") {
              jQuery('#input-note-' + order_uid).slideDown();
              jQuery('#input-sage-' + order_uid).slideUp();
              jQuery('#input-notes-' + order_uid).slideUp();
          } else {
              jQuery('#input-sage-' + order_uid).slideUp();
              jQuery('#input-note-' + order_uid).slideUp();
              jQuery('#input-notes-' + order_uid).slideUp();
          }

      });

      jQuery('.order-processing').on('change', '.input-administer', function() {

          var order_uid = jQuery(this).data('approve');
          var action = jQuery(this).val();

          //console.log(order_uid);
          //console.log(action);

          if (action === "approve") {
              jQuery('.orderitems-' + order_uid).css('display','none');
          } else if (action === "reject") {
              jQuery('.orderitems-' + order_uid).css('display','table-row');
          } else {
              jQuery('.orderitems-' + order_uid).css('display','none');
          }

      });



    jQuery('.order-complete').on('change', '.input-action', function() {

      var order_uid = jQuery(this).data('deliver');
      var action = jQuery(this).val();

      if (action === "deliver") {
        jQuery('#input-notes-' + order_uid).slideDown();
      } else {
        jQuery('#input-notes-' + order_uid).slideUp();
      }

    });


    jQuery('#confirm-order').on('click', function() {
      if (jQuery(this).is(":checked")) {
        jQuery('#place-order-button').attr('disabled', false);
      } else {
        jQuery('#place-order-button').attr('disabled', 'disabled');
      }
    });

    jQuery(".disable-onclick-form").submit(function () {
      jQuery(".disable-onclick").attr("disabled", true);
      return true;
    });

      /* eslint-enable */















      /* eslint-disable */


      // for lost password
      jQuery("form#lostPasswordForm").submit(function(){
          var submit    = jQuery("div#lostPassword #wp-submit"),
              //preloader = jQuery("div#lostPassword #preloader"),
              message   = jQuery("div#lostPassword #message"),
              contents  = {
                  action:       'lost_pass',
                  nonce:        this.odl_user_lost_password_nonce.value,
                  user_login:   this.user_login.value,
              };

          // disable button onsubmit to avoid double submision
          submit.attr("disabled", "disabled").addClass('disabled');

          // Display our pre-loading
          //preloader.css({'visibility':'visible'});

          jQuery.post( odl_ajax.url, contents, function( data ){
              submit.removeAttr("disabled").removeClass('disabled');

              // hide pre-loader
              //preloader.css({'visibility':'hidden'});

              // display return data
              message.html( data );
          });

          return false;
      });


      // for reset password
      jQuery("form#resetPasswordForm").submit(function(){
          var submit    = jQuery("div#resetPassword #wp-submit"),
              //preloader = jQuery("div#resetPassword #preloader"),
              message   = jQuery("div#resetPassword #message"),
              contents  = {
                  action:       'reset_pass',
                  nonce:        this.odl_user_reset_password_nonce.value,
                  pass1:        this.pass1.value,
                  pass2:        this.pass2.value,
                  user_key:     this.user_key.value,
                  user_login:   this.user_login.value,
              };

          // disable button onsubmit to avoid double submision
          submit.attr("disabled", "disabled").addClass('disabled');

          // Display our pre-loading
          //preloader.css({'visibility':'visible'});

          jQuery.post( odl_ajax.url, contents, function( data ){
              submit.removeAttr("disabled").removeClass('disabled');

              // hide pre-loader
              //preloader.css({'visibility':'hidden'});

              // display return data
              message.html( data );
          });

          return false;
      });























    // new edit functionality


    // has a qty been changed?
    jQuery('.blinds-edit-order').on('change', '.input-quantity', function() {

      var rowid = jQuery(this).attr('id').replace("input-quantity-","");
      var worthdoing = false;

      if ( (jQuery('#input-width-' + rowid).val() !== "") && (jQuery('#input-height-' + rowid).val() !== "") ) {
        worthdoing = true;
      }

      if (worthdoing) {

        var formdata = jQuery('.blinds-edit-order').serialize();

        jQuery.ajax({
          type: 'POST',
          url: odl_ajax.url,
          data: formdata + "&row=" + rowid + "&action=admin_edit_row_ajax",
          success: function (data, textStatus, XMLHttpRequest) {

            var results = jQuery.parseJSON(data);

            if (results.status === "success") {

              console.log(results);

              jQuery('#input-unit-total-' + results.row).val(results.unit);
              jQuery('#input-total-' + results.row).html(results.total);

              recalculate_total_value_edit();

            } else if (results.status === "error") {

              console.log('error');

              /*jQuery('#note-message').slideUp(300, function() {
               jQuery('#note-message-info').html('').fadeOut();
               jQuery('#note-message-error').html(results.message).fadeIn();
               jQuery('#note-message').slideDown(300).fadeIn();
               });*/

            }

          },
          error: function (MLHttpRequest, textStatus, errorThrown) {
            console.log(MLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
            alert('Error, please contact support.');
          },
        });

      }

    });

    // has a function been changed?
    jQuery('.blinds-edit-order').on('change', '.input-function', function() {

      var rowid = jQuery(this).attr('id').replace("input-function-","");
      var worthdoing = false;

      if ( (jQuery('#input-width-' + rowid).val() !== "") && (jQuery('#input-height-' + rowid).val() !== "") ) {
        worthdoing = true;
      }

      if (worthdoing) {

        var formdata = jQuery('.blinds-edit-order').serialize();

        jQuery.ajax({
          type: 'POST',
          url: odl_ajax.url,
          data: formdata + "&row=" + rowid + "&action=admin_edit_row_ajax",
          success: function (data, textStatus, XMLHttpRequest) {

            var results = jQuery.parseJSON(data);

            if (results.status === "success") {

              console.log(results);

              jQuery('#input-unit-total-' + results.row).val(results.unit);
              jQuery('#input-total-' + results.row).html(results.total);

              recalculate_total_value_edit();

            } else if (results.status === "error") {

              console.log('error');

              /*jQuery('#note-message').slideUp(300, function() {
               jQuery('#note-message-info').html('').fadeOut();
               jQuery('#note-message-error').html(results.message).fadeIn();
               jQuery('#note-message').slideDown(300).fadeIn();
               });*/

            }

          },
          error: function (MLHttpRequest, textStatus, errorThrown) {
            console.log(MLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
            alert('Error, please contact support.');
          },
        });

      }

    });



    // has a dimension been changed?
    jQuery('.blinds-edit-order').on('change', '.input-width', function() {

      var rowid = jQuery(this).attr('id').replace("input-width-","");
      var worthdoing = false;

      if ( (jQuery('#input-width-' + rowid).val() !== "") && (jQuery('#input-height-' + rowid).val() !== "") ) {
        worthdoing = true;
      }

      if (worthdoing) {

        var formdata = jQuery('.blinds-edit-order').serialize();

        jQuery.ajax({
          type: 'POST',
          url: odl_ajax.url,
          data: formdata + "&row=" + rowid + "&action=admin_edit_row_ajax",
          success: function (data, textStatus, XMLHttpRequest) {

            var results = jQuery.parseJSON(data);

            if (results.status === "success") {

              console.log(results);

              jQuery('#input-unit-total-' + results.row).val(results.unit);
              jQuery('#input-total-' + results.row).html(results.total);

              recalculate_total_value_edit();

            } else if (results.status === "error") {

              console.log('error');

              /*jQuery('#note-message').slideUp(300, function() {
               jQuery('#note-message-info').html('').fadeOut();
               jQuery('#note-message-error').html(results.message).fadeIn();
               jQuery('#note-message').slideDown(300).fadeIn();
               });*/

            }

          },
          error: function (MLHttpRequest, textStatus, errorThrown) {
            console.log(MLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
            alert('Error, please contact support.');
          },
        });

      }

    });

    jQuery('.blinds-edit-order').on('change', '.input-height', function() {

      var rowid = jQuery(this).attr('id').replace("input-height-","");
      var worthdoing = false;

      if ( (jQuery('#input-width-' + rowid).val() !== "") && (jQuery('#input-height-' + rowid).val() !== "") ) {
        worthdoing = true;
      }

      if (worthdoing) {

        var formdata = jQuery('.blinds-edit-order').serialize();

        jQuery.ajax({
          type: 'POST',
          url: odl_ajax.url,
          data: formdata + "&row=" + rowid + "&action=admin_edit_row_ajax",
          success: function (data, textStatus, XMLHttpRequest) {

            var results = jQuery.parseJSON(data);

            if (results.status === "success") {

              console.log(results);

              jQuery('#input-unit-total-' + results.row).val(results.unit);
              jQuery('#input-total-' + results.row).html(results.total);

              recalculate_total_value_edit();

            } else if (results.status === "error") {

              console.log('error');

              /*jQuery('#note-message').slideUp(300, function() {
               jQuery('#note-message-info').html('').fadeOut();
               jQuery('#note-message-error').html(results.message).fadeIn();
               jQuery('#note-message').slideDown(300).fadeIn();
               });*/

            }

          },
          error: function (MLHttpRequest, textStatus, errorThrown) {
            console.log(MLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
            alert('Error, please contact support.');
          },
        });

      }

    });



    function recalculate_total_value_edit() {

      var formdata = jQuery('.blinds-edit-order').serialize();

      jQuery.ajax({
        type: 'POST',
        url: odl_ajax.url,
        data: formdata + "&action=admin_edit_row_totals_ajax",
        success: function (data, textStatus, XMLHttpRequest) {

          var results = jQuery.parseJSON(data);

          if (results.status === "success") {

            jQuery('#edit-order-subtotal').html(results.subtotal);
            jQuery('#edit-order-delivery').html(results.delivery);
            jQuery('#edit-order-vat').html(results.vat);
            jQuery('#edit-order-total').html(results.total);

          } else if (results.status === "error") {

            console.log('error');

            /*jQuery('#note-message').slideUp(300, function() {
             jQuery('#note-message-info').html('').fadeOut();
             jQuery('#note-message-error').html(results.message).fadeIn();
             jQuery('#note-message').slideDown(300).fadeIn();
             });*/

          }

        },
        error: function (MLHttpRequest, textStatus, errorThrown) {
          console.log(MLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
          alert('Error, please contact support.');
        },
      });

    }






    // has a unit price been changed?
    jQuery('.blinds-edit-order').on('change', '.input-unit-total', function() {

      var rowid = jQuery(this).attr('id').replace("input-unit-total-","");

      var formdata = jQuery('.blinds-edit-order').serialize();

      jQuery.ajax({
        type: 'POST',
        url: odl_ajax.url,
        data: formdata + "&row=" + rowid + "&action=admin_edit_price_ajax",
        success: function (data, textStatus, XMLHttpRequest) {

          var results = jQuery.parseJSON(data);

          if (results.status === "success") {

            jQuery('#edit-order-subtotal').html(results.subtotal);
            jQuery('#edit-order-delivery').html(results.delivery);
            jQuery('#edit-order-vat').html(results.vat);
            jQuery('#edit-order-total').html(results.total);

            jQuery.each( results.rows, function( index, value ){
              jQuery('#input-total-' + index).html(value);
            });


          } else if (results.status === "error") {

            console.log('error');

            /*jQuery('#note-message').slideUp(300, function() {
             jQuery('#note-message-info').html('').fadeOut();
             jQuery('#note-message-error').html(results.message).fadeIn();
             jQuery('#note-message').slideDown(300).fadeIn();
             });*/

          }

        },
        error: function (MLHttpRequest, textStatus, errorThrown) {
          console.log(MLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
          alert('Error, please contact support.');
        },
      });

    });







    /* eslint-enable */















  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js